import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 8h1v8","key":"svg-0"}],["path",{"d":"M7 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4","key":"svg-1"}]]

const IconNumber51Small = createReactComponent('outline', 'number-51-small', 'Number51Small', __iconNode);

export default IconNumber51Small;